<template>
    <div class="page-content">
        <h1 v-if="contactData && isCompany">{{ contactData.name }}</h1>
        <h1 v-else-if="contactData">
            {{ contactData.firstname }} {{ contactData.lastname }}
        </h1>
        <b-card footer-class="p-0" class="rounded-lg">
            <company-edit v-if="editMode && isCompany" />
            <actor-edit v-else-if="editMode" />

            <contact-details-display v-else />

            <template v-slot:footer no-body>
                <b-tabs
                    card
                    lazy
                    ref="btabs"
                    class="list tab-table-responsive"
                    content-class="rounded-lg"
                    v-if="contactData && !isLoading"
                    v-model="activeTabIndex"
                    :key="cardKey"
                >
                    <tab-relationships :key="1 + keyComponent" />
                    <tab-communications
                        ref="tab-communication"
                        :key="2 + keyComponent"
                    />
                    <tab-tasks :key="3 + keyComponent" v-if="!isCompany" />
                </b-tabs>
            </template>
        </b-card>
        <div v-if="contactData">
            <modal-new-task
                ref="modalAddNewTask"
                module="contact"
                :current-client="contactData"
                @reload="reloadTab(2)"
            />
            <modal-log-communication
                ref="modalLogCommunication"
                :module="COMMUNICATION.MODULE_CONTACT"
                :contact-id="contactId"
                @onsuccess="reloadTab(1)"
            />
            <modal-send-sms
                ref="modalSendSms"
                :module="COMMUNICATION.MODULE_CONTACT"
                :contact-details="contactDetails"
                @sent="postSendSms"
                @onsuccess="reloadTab(1)"
            />

            <modal-send-email
                ref="modalSendEmail"
                :module="COMMUNICATION.MODULE_CONTACT"
                :contact-details="contactDetails"
                @onSendSuccess="reloadTab(1)"
            />
            <modal-switch-business
                ref="modalSwitchBusiness"
                @redirect-to-dashboard="redirectToDashboard"
            />
        </div>
    </div>
</template>
<script>
import TabTasks from "./tabs/tab-tasks";
import TabRelationships from "./tabs/tab-relationships";
import TabCommunications from "./tabs/tab-communications";
import ContactDetailsDisplay from "@/components/contact-details/details-display";
import ActorEdit from "@/components/contact-details/actor-edit";
import CompanyEdit from "@/components/contact-details/company-edit";
import ModalLogCommunication from "@/components/communication/communication-log-modal";
import ModalSendSms from "@/components/communication/communication-send-sms";
import ModalSendEmail from "@/components/communication/communication-send-email";
import ModalNewTask from "@/components/tasks/task-update-modal";
import COMMUNICATION from "@/constants/communications";
import ModalSwitchBusiness from "@/components/commons/modal-switch-business.vue";

export default {
    components: {
        TabTasks,
        TabRelationships,
        TabCommunications,
        ModalNewTask,
        ContactDetailsDisplay,
        ActorEdit,
        CompanyEdit,
        ModalLogCommunication,
        ModalSendSms,
        ModalSendEmail,
        ModalSwitchBusiness
    },
    data() {
        return {
            resources: {},
            keyComponent: 0,
            activeTabIndex: 0,
            cardKey: 0,
            isLoading: false,
            COMMUNICATION: COMMUNICATION
        };
    },
    watch: {
        "$route.params.id": {
            handler() {
                this.$store.commit("contact/setEditMode", false);
                this.reloadPageDetails();
            }
        }
    },
    computed: {
        editMode() {
            return this.$store.state.contact.editMode;
        },
        contactData() {
            return this.$store.getters["contact/contactDetails"];
        },
        contactId() {
            return this.$store.state.contact.contactId;
        },
        contactEncodedId() {
            return this.$route.params.id;
        },
        isCompany() {
            return this.$route.name === "contact_company";
        },
        contactDetails() {
            return this.$store.state.contact.contactDetails;
        }
    },
    created() {},
    mounted() {
        let self = this;
        self.init();
        self.$root.$on("open-modal-contact", function (ref, comm) {
            self.$refs[ref].open(comm);
        });
    },
    beforeDestroy: function () {
        this.$store.commit("contact/setEditMode", false);
        this.$root.$off("open-modal-contact");
    },
    methods: {
        init() {
            let self = this;
            self.isLoading = true;

            if (this.isCompany) {
                this.$store
                    .dispatch("contact/getContactCompanyDetails", {
                        id: this.contactEncodedId
                    })
                    .then(response => {
                        if (response.switch_business) {
                            //switch clinic/business when checking in PreventRestrictedUser middleware
                            this.$refs.modalSwitchBusiness.open(response);
                        } else if (response.no_access) {
                            //no access when checking in PreventRestrictedUser middleware
                            self._message(response.message, "danger");
                            self.redirectToDashboard();
                        } else {
                            self.dynamicPageTitle(response.resource.name);
                            self.cardKey++;
                            self.isLoading = false;
                            self.storeAudit("company");
                        }
                    });
            } else {
                this.$store
                    .dispatch("contact/getContactActorDetails", {
                        id: this.contactEncodedId
                    })
                    .then(response => {
                        if (response.switch_business) {
                            //switch clinic/business when checking in PreventRestrictedUser middleware
                            this.$refs.modalSwitchBusiness.open(response);
                        } else if (response.no_access) {
                            //no access when checking in PreventRestrictedUser middleware
                            this._message(response.message, "danger");
                            self.redirectToDashboard();
                        } else {
                            self.dynamicPageTitle(
                                response.resource.display_name
                            );
                            self.cardKey++;
                            self.isLoading = false;
                            self.storeAudit("contact");
                        }
                    });
            }
        },
        async reloadPageDetails() {
            this.activeTabIndex = 0;
            await this.init();

            this._getSetting().then(() => {
                this.$nextTick(() => {
                    this.dataLoaded = true;
                });
            });
        },
        async storeAudit(type) {
            const contactId = _.clone(this.contactId);
            const fullPath = _.clone(this.$router.currentRoute.fullPath);

            if (!contactId) {
                return;
            }

            this._getSetting().then(() => {
                this._saveAudit({
                    action: "view",
                    path: `/contact/${type}/view.` + contactId,
                    reference_id: contactId,
                    fullPath
                });
            });
        },
        reloadTab(tabIndex) {
            this.activeTabIndex = tabIndex;
            this.keyComponent++;
        },
        postSendSms(isChangeNumber = false, mobileNumberObject) {
            this.reloadTab(1);

            if (isChangeNumber) {
                this.$store.commit(
                    "contact/setContactDetailPhoneNumber",
                    mobileNumberObject
                );
            }
        },
        redirectToDashboard() {
            this.$router.push({ name: "contact_dashboard" });
        }
    }
};
</script>
